import type { RouteObject } from "react-router-dom";
import RootLayout from "@/components/feature/RootLayout";
import Home from "@/pages/home/page";
import Works from "@/pages/works/page";
import WorkDetail from "@/pages/works/detail/page";
import Profile from "@/pages/profile/page";
import News from "@/pages/news/page";
import NewsDetail from "@/pages/news/detail/page";
import Search from "@/pages/search/page";
import About from "@/pages/about/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <RootLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "works", element: <Works /> },
      { path: "works/:id", element: <WorkDetail /> },
      { path: "profile", element: <Profile /> },
      { path: "news", element: <News /> },
      { path: "news/:id", element: <NewsDetail /> },
      { path: "search", element: <Search /> },
      { path: "about", element: <About /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;